var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgSponsorsNp2019(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M373.2 23.2H21c-4 0-7.1 3.5-7.1 7.5v194.5c0 4 3.5 7.5 7.5 7.5H150l47.3 47.3 47.3-47.3h128.6c4 0 7.5-3.5 7.5-7.5V30.7C380.8 26.7 377.2 23.2 373.2 23.2z",
    style: {
      fill: "#E8CA8F",
      strokeWidth: 10,
      stroke: "#FFF"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgSponsorsNp2019);
export default __webpack_public_path__ + "static/media/svg_sponsors_NP_2019.640d188ce26cb924f95b3295f844acb1.svg";
export { ForwardRef as ReactComponent };